import { render, staticRenderFns } from "./AgendaViewMeetingTypeColumn.vue?vue&type=template&id=5dcab78c&"
import script from "./AgendaViewMeetingTypeColumn.vue?vue&type=script&lang=js&"
export * from "./AgendaViewMeetingTypeColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
